import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LineTabs from './LineTabs';

// Tabs that are routes: each `Tab` names its path (`label`) and its title
// (`tabName`); a click goes there and shows its content. The strip is the
// orange underlined one of the panels (LineTabs).
function Tabs({ children }) {
  const pathname = useLocation().pathname.split('/')[2];
  const [activeTab, setActiveTab] = useState(pathname);
  const navigate = useNavigate();

  const open = (label) => {
    setActiveTab(label);
    navigate(`./${label}`, { replace: true });
  };

  return (
    <div>
      <LineTabs
        className="ml-3"
        activeTab={activeTab}
        onChange={open}
        tabs={children.map((child) => ({ id: child.props.label, label: child.props.tabName }))}
      />
      <div>{children.filter((child) => child.props.label === activeTab)}</div>
    </div>
  );
}

function Tab(props) {
  return <>{props.children}</>;
}

export { Tabs, Tab };
